// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"226":"765ec6ead9f31e65","339":"156a8702732b7980","484":"fc0f39476fe0096f","641":"b52fc9e8326f31de","788":"75b0af6da87da268"}[chunkId] + ".js";
};